import AccordionItemHandler from '@/components/forms/new/AccordionItemHandler';
import { Box } from '@chakra-ui/react';
import ItemInvoiceToggle from '../formFields/ItemInvoiceToggle';
import InvoiceExportToggles from '../formFields/InvoiceExportToggles';
import BillingNoteTable from 'pages/organisations/sharedComponents/BillingNoteTable';
import { FORM_FIELD_PATHS } from '../../constants';
import { usePartnerForm } from '../../hooks/usePartnerForm';

const PartnerInvoiceSettings = ({
    errors,
    touched,
    darkMode,
}) => {
    const {
        updateFormData,
        formData,
        deletedBillingNoteIDs,
        setDeletedBillingNoteIDs,
    } = usePartnerForm();

    const setBillingState = (payload) => {
        updateFormData(
            FORM_FIELD_PATHS.BILLING_NOTES,
            payload.billingNotes,
        );
    };

    const formFields = () => {
        const fields = [
            <ItemInvoiceToggle key="itemInvoiceToggle" darkMode={darkMode} />,
            <InvoiceExportToggles key="invoiceExportToggles" />,
            <Box key="billingNoteTable" paddingTop="20px">
                <BillingNoteTable
                    setBillingState={setBillingState}
                    formData={formData}
                    mode="Partner"
                    updateFormData={updateFormData}
                    deletedBillingNoteIDs={deletedBillingNoteIDs}
                    setDeletedBillingNoteIDs={setDeletedBillingNoteIDs}
                />
            </Box>,
        ];

        return fields;
    };
    return (
        <AccordionItemHandler
            index={1}
            key="partnerBillingInvoiceExport"
            label="Invoice Export"
            errors={errors}
            touched={touched}
            defaultIsOpen={true}>
            {formFields()}
        </AccordionItemHandler>
    );
};

export default PartnerInvoiceSettings;
